import moment from 'moment';

export const templates = {
  openMap: '5a4364dfb221246bdceb4acb',
  aliasMap: '5f2f80bfcb8cdca929c3e77c',
  spotCollectionMap: '5f2f80bfcb8cdca929c3e77e',
};

/**
 * @type {(map?: Pick<WEB_MAP_READ_NEW, 'account_id' | 'session_account_id'>) => boolean}
 */
export const isMapOwner = (map) => {
  if (!map && typeof window === 'undefined') {
    return false;
  }

  const newMap = map || window.Gdata.CurrentMap.ori[0];
  return String(newMap.account_id) === String(newMap.session_account_id);
};

/**
 * @type {(template: keyof typeof templates, map?: Pick<WEB_MAP_READ_NEW, 'template_id'>) => boolean}
 */
export const isTemplate = (template, map) => {
  if (!map && typeof window === 'undefined') {
    return false;
  }

  const newMap = map || window.Gdata.CurrentMap.ori[0];
  return String(newMap.template_id) === templates[template];
};

/**
 * @param {Pick<map, 'alias_map_event_start_datetime' | 'alias_map_event_end_datetime'>} map
 */
export const isAliasMapDuringEvent = (map) => {
  const now = moment().utc().format('YYYY-MM-DD HH-mm-ss');
  return (
    now > (map.alias_map_event_start_datetime || now) &&
    now < (map.alias_map_event_end_datetime || now)
  );
};

/**
 * @param {Pick<map, 'alias_map_after_play_enabled' | 'alias_map_after_play_start_datetime' | 'alias_map_event_end_datetime'>} map
 */
export const isAliasMapDuringAfterPlay = (map) => {
  const now = moment().utc().format('YYYY-MM-DD HH-mm-ss');
  return (
    map.alias_map_after_play_enabled &&
    !!map.alias_map_after_play_start_datetime &&
    now >= map.alias_map_after_play_start_datetime &&
    now < (map.alias_map_event_end_datetime || now)
  );
};
